fragment VariantFragment on ProductVariant {
  id
  title
  price {
    amount
    currencyCode
  }
  unitPrice {
    amount
    currencyCode
  }
  unitPriceMeasurement {
    measuredType
    quantityUnit
    quantityValue
    referenceUnit
    referenceValue
  }
  weight
  available: availableForSale
  sku
  compareAtPrice {
    amount
    currencyCode
  }
  image {
    id
    src: originalSrc
    altText
    width
    height
  }
  selectedOptions {
    name
    value
  }
}
